<template>
  <div class="select-list-wrap">
    <div class="select-title">{{ title }}</div>
    <div class="select-list">
      <div
        v-for="(item, index) in selectList"
        :key="index"
        :class="['select-item', modelValue.includes(item.value) ? 'select-item-active' : '']"
        @click.stop="clickItem(item, index)"
      >
        {{ item.label }}
      </div>
      <div v-if="other != undefined" :class="['select-item', hasSelectOther ? 'select-item-active' : '']" @click.stop="clickOther()">其他</div>
    </div>
    <div class="textarea-box other" v-if="hasSelectOther">
      <textarea
        class="textarea"
        v-model="otherValue"
        :placeholder="placeholder"
        maxlength="150"
        @input="otherChange"
      ></textarea>
      <div class="count">{{ otherValue.length }}/150</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ESelect',
  props: {
    selectList: {
      type: Array,
      default: () => [],
    },
    changeAble: {
      type: Boolean,
      default: true,
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
      default: 9999,
    },
    other: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: '请输入其他内容',
    },
  },
  data() {
    return {
      otherValue: '',
      selectValue: [],
      hasSelectOther: false,
    };
  },
  watch: {
    other: {
      handler(n) {
        if (n) {
          this.hasSelectOther = true;
          this.otherValue = n;
        }
      },
      immediate: true,
    },
    modelValue: {
      handler(n) {
        if (n && this.selectList) {
          this.selectValue = this.selectList.reduce((pre, cur) => n.includes(cur.value) ? pre.concat(cur.value) : pre, []);
        }
      },
      immediate: true,
      deep: true,
    },
    selectList: {
      handler(n) {
        if (this.modelValue && n) {
          this.selectValue = this.selectList.reduce((pre, cur) => this.modelValue.includes(cur.value) ? pre.concat(cur.value) : pre, []);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    otherChange() {
      this.$emit('on-other', this.otherValue);
    },
    clickItem(item) {
      // debugger;
      if (!this.changeAble) return;
      if (item.value === '无') {
        this.otherValue = '';
        this.$emit('on-other', this.otherValue);
        if (this.hasSelectOther) {
          this.hasSelectOther = false;
        }
        this.selectValue = [];
      }
      // if (this.selectValue.includes('无')) {
      //   this.otherValue = '';
      //   this.$emit('on-other', this.otherValue);
      //   if (this.selectValue.length < this.count) {
      //     this.selectValue = [];
      //     this.selectValue.push(item.value);
      //   }
      //   return;
      // }
      if (this.count === 1) {
        this.selectValue = [item.value];
        if (this.hasSelectOther) {
          this.hasSelectOther = false;
        }
      } else if (this.selectValue.includes(item.value)) {
        this.selectValue.splice(this.selectValue.indexOf(item.value), 1);
      } else if (this.selectValue.length < this.count) {
        if (this.hasSelectOther && this.selectValue.length === this.count - 1) {
          return;
        }
        if (this.selectValue.includes('无')) {
          this.selectValue = [];
        }
        this.selectValue.push(item.value);
      }
      console.error(this.selectValue);
      this.$emit('update:modelValue', this.selectValue);
      this.$emit('on-change', this.selectValue);
    },
    clickOther() {
      if (this.selectValue.includes('无')) {
        this.selectValue = [];
        this.$emit('update:modelValue', this.selectValue);
        this.$emit('on-change', this.selectValue);
      }
      if (this.selectValue.length >= this.count && this.count > 1) {
        return;
      }
      this.hasSelectOther = !this.hasSelectOther;
      if (!this.hasSelectOther) {
        this.otherValue = '';
        this.$emit('on-other', this.otherValue);
      }
      if (this.count === 1 && this.hasSelectOther) {
        this.selectValue = [];
        console.error('mmm', this.selectValue);
        this.$emit('update:modelValue', this.selectValue);
        this.$emit('on-change', this.selectValue);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.select-list-wrap {
  margin-bottom: 15px;

  .select-title {
    @include font(16px, 24px, #666);

    margin-bottom: 15px;
  }

  .select-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .select-item {
      background: #f5f5f5;
      border-radius: 17px;

      @include font(16px, 24px, #9A9FA8);

      padding: 4px 14px;
      margin-right: 15px;
      margin-bottom: 15px;
      border: 1px solid #f5f5f5;
    }

    .select-item-active {
      background: #ecfff7;
      border: 1px solid #01bb6e;
      color: #01bb6e;
    }
  }
}

.textarea-box {
  display: block;
  width: 100%;
  height: 150px;
  background-color: $background-color-2;
  border-radius: $regular-border-radius;

  .textarea {
    @include font(16px, 24px);

    width: 100%;
    height: 118px;
    padding: 12px 15px;
    box-sizing: border-box;
    resize: none;
  }

  .count {
    @include font(14px, 20px, $regular-text-color, right);

    padding: 0 15px;
  }

  &.other {
    height: 127px;

    .textarea {
      height: 95px;
    }
  }
}
</style>
